/**
 * Wrap SSJS in browser checks so we can
 * use same code locally and in Matrix
 * @return {boolean}
 */
export function isBrowser() {
    return (
        typeof window === "object" &&
        typeof Window === "function" &&
        window instanceof Window
    );
}

export function isLocal() {
    return (
        isBrowser() &&
        /^(localhost|(?:[0-9]{1,3}\.){3}[0-9]{1,3})/.test(window.location.host)
    );
}

// helper fn: convert nodelist => Array
export function querySelectorArray(querySelector) {
    return Array.from(document.querySelectorAll(querySelector));
}

export class ApiError {
    constructor(error) {
        this.error = error;
        console.error(error);
    }

    getMessage() {
        return this.error.message;
    }
}

export function getParameterByName(name, url = window.location.href) {
    /* eslint-disable no-useless-escape */
    // https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
